<div class="template-filter">
  <div class="filter-layout">
    <div class="template-options" *ngIf="visibleFilters">
      <label for="template" class="template-filter-label"
        >{{ 'Template Filter' | translate }} :</label
      >
      <mat-chip-set #chipList>
        <mat-chip
          *ngFor="let template of uniqueTemplates"
          [removable]="false"
          (click)="toggleTemplateSelection(template)"
          [ngClass]="
            selectedTemplates.includes(template)
              ? 'template-selected'
              : 'template-unselected'
          "
        >
          {{ template }}
        </mat-chip>
      </mat-chip-set>
    </div>
  </div>
  <div class="legend-toggle">
    <mat-slide-toggle
      [(ngModel)]="isLimits"
      (change)="refreshChart()"
      *ngIf="visibleLimits"
    >
      {{ 'Limits' | translate }}</mat-slide-toggle
    >
    <mat-slide-toggle
      [(ngModel)]="isLegend"
      (change)="refreshChart()"
      *ngIf="visibleLegend"
    >
      {{ 'Legend' | translate }}</mat-slide-toggle
    >
  </div>
</div>
<div style="position: relative; height: 90%; width: 100%">
  <canvas
    #myChart
    aria-label="Standard Language Assessment Graph"
    role="img"
  ></canvas>
</div>
